
import React from 'react'
import {Input} from "antd";
import twelve_img from "../../../../images/config/authorizationProgress/12.png"
import thirteen_img from "../../../../images/config/authorizationProgress/13.png"
import fourteen_img from "../../../../images/config/authorizationProgress/14.png"
import {CopyToClipboard} from "react-copy-to-clipboard"
import Message from "../../../common/message";
import CorpApi from "../../../public/corp_api";
class AuthorizationCallback extends React.Component {
    constructor(props){
        super(props);
        this.handleCopyUrl=this.handleCopyUrl.bind(this)
        this.handleCopyToken=this.handleCopyToken.bind(this)
        this.handleCopyEncodingAESKey=this.handleCopyEncodingAESKey.bind(this)
        this.state={
            url:'',
            token:'',
            aeskey:''
        }
    }
    componentDidMount() {
        CorpApi.getCallbackUseMessage((data)=>{
            this.setState({
                url:data.url,
                token:data.token,
                aeskey:data.aeskey
            })
        },()=>{
            Message.error('获取失败！')
        })
    }

    //复制URL
    handleCopyUrl(e){
        if(this.state.url==e){
            try{Message.success("复制成功", null, null, true);}catch (e) {}
        }
    }
    handleCopyToken(e){
        if(this.state.token==e){
            try{Message.success("复制成功", null, null, true);}catch (e) {}
        }
    }
    handleCopyEncodingAESKey(e){
        if(this.state.aeskey==e){
            try{Message.success("复制成功", null, null, true);}catch (e) {}
        }
    }
    render() {
        return (
            <div className={'authorizationCallback'}>
                <div>
                    <div>（1）点击【应用管理】-【自建】中创建的【紫鲲】</div>
                    <div><img src={twelve_img}/></div>
                    <div>（2）找到【功能】中的【接收消息】，点击【设置API接收】，进行设置</div>
                    <div><img src={thirteen_img}/></div>
                    <div>（3）将以下内容依次填写到页面【接收消息服务器配置】下对应的输入框中</div>
                    <div className={'authorization_Input_Change'}>
                        <span>*URL：</span>
                        <span>
                            <Input size='smallz' placeholder="请输入URL" value={this.state.url} disabled/>
                        </span>
                        <CopyToClipboard
                            text={this.state.url}
                            onCopy={this.handleCopyUrl}
                        >
                            <span>复制</span>
                        </CopyToClipboard>
                    </div>
                    <div className={'authorization_Input_Change'}>
                        <span>*Token：</span>
                        <span>
                            <Input size='smallz' placeholder="请输入URL" value={this.state.token} disabled/>
                        </span>
                        <CopyToClipboard
                            text={this.state.token}
                            onCopy={this.handleCopyToken}
                        >
                            <span>复制</span>
                        </CopyToClipboard>
                    </div>
                    <div className={'authorization_Input_Change'}>
                        <span>*EncodingAESKey：</span>
                        <span>
                            <Input size='smallz' placeholder="请输入EncodingAESKey" value={this.state.aeskey} disabled/>
                        </span>
                        <CopyToClipboard
                            text={this.state.aeskey}
                            onCopy={this.handleCopyEncodingAESKey}
                        >
                            <span>复制</span>
                        </CopyToClipboard>
                    </div>
                    <div>在【选择需要接受的事件类型】中，一定要勾选【用户发送的普通消息】和【外部联系人变更回调】，否则会导致部分功能无法使用</div>
                    <div><img src={fourteen_img}/></div>
                </div>
            </div>
        )
    }
}

export default AuthorizationCallback
